export const ModalBackdrop = () => {
  return (
    <div className="pointer-events-none fixed inset-0 overflow-hidden bg-gray-50/80 backdrop-blur">
      <div className="absolute top-1/2 left-1/2 size-[100vmax] -translate-1/2 blur-[175px]">
        <div className="absolute top-1/5 left-2/5 size-1/3 -translate-1/2 rounded-full bg-malachite-50/80" />
        <div className="absolute top-2/5 left-3/5 size-1/3 -translate-1/2 rounded-full bg-yellow-50/80" />
        <div className="absolute top-3/5 left-1/5 size-1/3 -translate-1/2 rounded-full bg-blue-50/80" />
        <div className="absolute top-4/5 left-2/5 size-1/4 -translate-1/2 rounded-full bg-blue-50/80" />
        <div className="absolute top-3/5 left-4/5 size-1/3 -translate-1/2 rounded-full bg-indigo-50/80" />
      </div>
    </div>
  );
};
